import React, { useState } from 'react'
import * as PropTypes from 'prop-types'

const FilterContext = React.createContext([null, () => {}])

const FilterProvider = ({ children }) => {
  const [isFilterOpen, setFilterOpen] = useState(false)
  const [selectedCategories, setSelectedCategories] = React.useState([])

  return (
    <FilterContext.Provider
      value={{
        isFilterOpen,
        setFilterOpen,
        selectedCategories,
        setSelectedCategories,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

FilterProvider.propTypes = {
  children: PropTypes.arrayOf(PropTypes.shape({})),
}
FilterProvider.defaultProps = {
  children: [],
}

export { FilterContext, FilterProvider }
